// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"450":"About","653":"Projects","994":"Project"}[chunkId] + "." + {"450":"53a3a300","653":"dd3d1f73","994":"828bbb4d"}[chunkId] + ".css";
};